<template>
  <div id="locationForm" class="form">
    <v-card-title>
      {{ id ? "Edit " : "Add " }} {{ terminologies.center }}
      <v-spacer />
      <v-btn icon @click="goBack"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-form
        v-if="loaded"
        ref="form"
        v-model="valid"
        lazy-validation
        class="mt-5"
      >
        <v-row>
          <v-col>
            <v-text-field
              v-model="location.name"
              label="Location Name"
              :rules="[rules.required]"
              required
              outlined
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-text-field
              v-model="location.email"
              label="Email"
              :rules="[rules.email]"
              outlined
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-text-field
              v-model="location.codeName"
              label="Code Name"
              outlined
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-text-field
              v-model="location.phoneNumber"
              label="Phone Number"
              outlined
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-text-field
              v-model="location.lat"
              label="Location Latitude"
              :required="false"
              outlined
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model="location.lng"
              label="Location Longitude"
              :required="false"
              outlined
            />
          </v-col>
        </v-row>

        <v-textarea
          v-model="location.address"
          label="Address"
          :required="false"
          outlined
        />
        <v-textarea
          v-model="location.receiptHeader"
          label="Receipt Header"
          :required="false"
          outlined
        />
        <v-textarea
          v-model="location.invoiceHeader"
          label="Invoice Header"
          :required="false"
          outlined
        />

        <v-sheet class="d-md-flex">
          <v-sheet class="flex-column"> </v-sheet>
          <v-spacer></v-spacer>
          <v-sheet class="justify-right text-right">
            <v-btn @click="goBack" plain class="mr-4"> Back </v-btn>
            <v-btn @click="handleSubmit" color="primary" rounded x-large>
              {{ id ? "Update" : "Save" }}
            </v-btn>
          </v-sheet>
        </v-sheet>
      </v-form>
    </v-card-text>
  </div>
</template>

<script>
import { getLocation } from "@/services/location";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "LocationForm",
  props: ["id", "isModal"],
  data() {
    return {
      loaded: false,
      valid: false,
      location: {
        relations: {},
        name: "",
        codeName: "",
        code: "0",
        lat: "",
        lng: "",
        email: "",
        phoneNumber: "",
        address: "",
        receiptHeader: "",
        invoiceHeader: "",
      },
      rules: {
        required: (value) => !!value || "This field is required.",
        email: (value) =>
          !value ||
          /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
          "Invalid email.",
        validPhoneNumber: (value) => {
          const usPattern = /^\+1\d{10}$/;
          if (usPattern.test(value)) {
            return true;
          } else {
            return "Invalid phone number. Please enter mobile phone number.";
          }
        },
      },
    };
  },
  created() {
    this.setInstance();
  },
  computed: {
    ...mapGetters("terminology", ["terminologies"]),
  },
  methods: {
    ...mapActions("location", ["createLocation", "updateLocation"]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage",
    ]),

    async handleSubmit() {
      if (this.$refs.form.validate()) {
        if (this.id) {
          let location = this.location;
          delete location.relations;

          this.updateLocation(location)
            .then((response) => {
              console.log(response);
              this.addSuccessMessage("Location was updated successfully");
              this.goBack();
            })
            .catch(() => {
              this.addErrorMessage(
                "Error updating Location, please try again later",
              );
            });
        } else {
          let location = this.location;
          delete location.relations;

          this.createLocation(location)
            .then((response) => {
              console.log(response);
              this.addSuccessMessage("Location was created successfully");
              this.goBack();
            })
            .catch(() => {
              this.addErrorMessage(
                "Error creating Location, please try again later",
              );
            });
        }
      }
    },
    goBack() {
      if (this.isModal) {
        this.onCloseDialog();
      } else {
        this.$router.go(-1);
      }
    },
    setInstance() {
      if (this.id) {
        this.location.id = this.id;
        getLocation(this.id).then((response) => {
          let instance = response.data;
          for (let property in instance) {
            if (
              Object.prototype.hasOwnProperty.call(instance, property) &&
              Object.prototype.hasOwnProperty.call(this.location, property)
            ) {
              this.location[property] = instance[property];
            }
          }
          this.loaded = true;
        });
      } else {
        this.loaded = true;
      }
      this.setDependencies();
    },
    setDependencies() {},
    onCloseDialog() {
      this.id = null;
      this.$emit("clicked", "closeLocationDialog");
    },
  },
  components: {},
};
</script>
